import React from 'react';
import PropTypes from 'prop-types';

// Components
import { ProfileForm, ErrorBoundary } from '../../components';

/**
 * ProfileInfoView component for displaying and managing customer profile information
 *
 * @param {Object} props - Component props
 * @param {Object} props.customerData - Current customer data
 * @param {Function} props.setCustomerData - Function to update customer data
 * @returns {JSX.Element} ProfileInfoView component
 */
const ProfileInfoView = ({ customerData, setCustomerData }) => {
  // Render main content - all data management is handled by parent Account component
  return (
    <ErrorBoundary>
      <div className="profile-info-view">
        <ProfileForm customerData={customerData} setCustomerData={setCustomerData} />
      </div>
    </ErrorBoundary>
  );
};

// PropTypes for type checking
ProfileInfoView.propTypes = {
  customerData: PropTypes.shape({
    id: PropTypes.string,
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string,
    height: PropTypes.string,
    weight: PropTypes.string,
    body_shape: PropTypes.string,
    preferred_style: PropTypes.string,
    chat_sessions_available: PropTypes.number,
    video_sessions_available: PropTypes.number,
    total_chat_sessions: PropTypes.number,
    total_video_sessions: PropTypes.number,
  }),
  setCustomerData: PropTypes.func.isRequired,
};

// Default props
ProfileInfoView.defaultProps = {
  customerData: {
    id: '',
    first_name: '',
    last_name: '',
    email: '',
    phone: '',
    height: '',
    weight: '',
    body_shape: '',
    preferred_style: '',
    chat_sessions_available: 0,
    video_sessions_available: 0,
    total_chat_sessions: 0,
    total_video_sessions: 0,
  },
};

export default ProfileInfoView;
